import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLFormElement> {
  connect() {
    if (this.element.href == window.location.href) {
      this.element.classList.add('nav-link__selected')
    }
  }
}
